import React from 'react'
import BlockUi from '@availity/block-ui'
import { Rings } from 'react-loader-spinner'

import styles from './Loader.module.scss'

/**
 * @param {Object} props
 * @param {boolean} props.loading - Whether to show the loader or the children.
 * @param {React.ReactNode} [props.children] - The content to show when not loading.
 */
export function Loader({ loading, children }) {
  return <BlockUi blocking={loading} loader={<Spinner />} renderChildren={false} children={children} keepInView />
}

export default Loader

export const LoaderSpinner = () => (
  <div className={styles.loader}>
    <Spinner />
  </div>
)

const Spinner = () => <Rings color='#00BFFF' height={80} width={80} />
